import { Location } from '@angular/common';
import { AuthService } from './../../services/auth.service';
import { ExpedientesService } from './../../services/expedientes.service';
import { IntervinientesService } from './../../services/intervinientes.service';
import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import 'rxjs/Rx';
import { saveAs } from 'file-saver/FileSaver';

@Component({
  selector: 'app-expediente-actuacion',
  templateUrl: './expediente-actuacion.component.html',
  styleUrls: ['./expediente-actuacion.component.css']
})
export class ExpedienteActuacionComponent implements OnInit {

  @ViewChild("mensaje") mensaje:ElementRef
  codigo;
  intervinientes=[];
  actuacion={};
  adjuntos=[];
  

  constructor(private location:Location, private auth:AuthService, private activatedRoute:ActivatedRoute, private intervinientesService:IntervinientesService,
    private expedientesService:ExpedientesService, private router:Router, private renderer:Renderer2) {

    if(!this.expedientesService.expedienteActivo){
      this.location.back();
    }

    this.activatedRoute.params.subscribe(params=>{
      this.codigo=params["cod"];
      
      
      if(this.codigo!="nuevo"){
        this.cargarActuacion();
        this.getActuacionAdjuntos();
      }else{
        this.actuacion={};
        if(this.auth.esInterviniente()){
          this.actuacion['EAinterviniente']=this.auth.usuarioActivo['INcodigo'];
        }
      }
    });

    
   }

  ngOnInit() {
    this.cargarIntervinientes();
    
    
  }

  cargarIntervinientes(){
    this.intervinientesService.getNombresIntervinientes().subscribe();
  }

  cargarActuacion(){
    this.expedientesService.getActuacion(this.codigo).subscribe(resp=>{
      this.actuacion=resp;
      
      this.actuacion["EAfechaapertura"]!=null?this.actuacion["EAfechaapertura"]=this.actuacion["EAfechaapertura"].substring(0,10):this.actuacion["EAfechaapertura"]="";
      this.actuacion["EAfechacierre"]!=null?this.actuacion["EAfechacierre"]=this.actuacion["EAfechacierre"].substring(0,10):this.actuacion["EAfechacierre"]="";

      return true;
    });
  }

  parseDate(dateString: string){
    if (dateString) {
      let fecha=new Date(dateString);
      var myDate_string = fecha.toISOString();
      var myDate_string = myDate_string.replace("T"," ");
      var myDate_string = myDate_string.substring(0,10);
        return myDate_string;
    } else {
        return null;
    }
  }

  guardarActuacion(){
    if(this.codigo!="nuevo"){
      this.updateActuacion();
    }else{
      this.insertActuacion();
    }
  }

  updateActuacion(){
    this.expedientesService.updateActuacion(this.actuacion,this.codigo)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["mensaje"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.location.back();
      }, 1500);
    });
  }

  insertActuacion(){
    this.expedientesService.insertActuacion(this.actuacion)
    .subscribe(resp=>{
      let texto=this.renderer.createText(resp["mensaje"]);
      this.renderer.appendChild(this.mensaje.nativeElement, texto);
      if(resp["err"]==false){
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "green");
      }else{
        this.renderer.setStyle(this.mensaje.nativeElement, "color", "red");
      }

      setTimeout(() => {
        this.location.back();
      }, 1500);
    });
  }

  getActuacionAdjuntos(){
    this.expedientesService.getActuacionAdjuntos(this.codigo).subscribe(resp=>{
      this.adjuntos=resp["adjuntos"];
    })
  }

  borrarAdjunto(codAdjunto){
    if(confirm("¿Desea borrar el adjunto de la actuacion seleccionado?")){
      this.expedientesService.borrarActuacionAdjunto(codAdjunto).subscribe(resp=>{
        this.getActuacionAdjuntos();
      });
    }
  }

  descargarAdjunto(i){
    this.expedientesService.descargarAdjuntoActuacion(this.adjuntos[i])
    .subscribe(data=>saveAs(data, this.adjuntos[i].EJfichero)),
    error=> console.log("Error downloading"),
    ()=>console.log("Nice.");
  }

  volver(){
    this.location.back();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/expediente-actuacion/expediente-actuacion.component.ts